import ToastNotification from '../components/common/toast-notification/ToastNotification';
import ms from 'ms';
import isEmpty from '../validation/is-empty';

export default function ProcessError(error, duration = '8s') {
  let { message } = error;
  let { extensions } = error.graphQLErrors[0];
  let { exception, code } = extensions;

  const errorMessage =
    exception?.invalidArgs ||
    message.replace('GraphQL error: ', '').replace('Error: ', '') ||
    message.replace('Network error: ', '').replace('Error: ', '') ||
    message.replace('Apollo error: ', '').replace('Error: ', '');

  // console.log(`message: ${errorMessage}`);
  // console.log(`code: ${code}`);

  const rateLimitError = !isEmpty(code) && code === 'TOO_MANY_REQUESTS';
  const isError =
    !isEmpty(code) &&
    (code === 'INTERNAL_SERVER_ERROR' ||
      code === 'UNAUTHORIZED' ||
      (code === 'BAD_REQUEST' && isEmpty(exception?.invalidArgs)) ||
      (code === 'NOT_FOUND' && isEmpty(exception?.invalidArgs)));

  // console.log(`isRateLimitError: ${rateLimitError}`);
  // console.log(`isServerError: ${isError}`);

  if (code === 'SESSION_HAS_EXPIRED') {
    ToastNotification({
      title: '¡Tu Sesión ha Caducado!',
      message:
        'Identificate de nuevo con tu email y contraseña para generar una sesión nueva.',
      type: 'info',
      duration: ms('8s'),
    });
  } else if (isError || rateLimitError) {
    // console.log(`show Toast Notification!!!`);

    ToastNotification({
      title: rateLimitError
        ? 'Bloqueo temporal'
        : code === 'UNAUTHORIZED'
        ? '¡No Autorizado!'
        : '¡Error!',
      message: errorMessage,
      type: rateLimitError ? 'warning' : 'danger',
      duration: rateLimitError ? ms('8s') : ms(duration),
    });
  }

  return {
    inputErrors: exception?.invalidArgs,
    ...(!isEmpty(code) && { errorCode: code }),
  };
}
